module.exports = __webpack_public_path__ + "static/img/school-15.593c7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-15.png
// module id = 87dw
// module chunks = 1